export default __webpack_public_path__ + "static/home-page-career-trades-6ba1827fbbfb5c827a0d609bec7e892c.png";